import { Button } from '@travelnest/merlin.button';
import { InlineError } from '@travelnest/merlin.inline-message';
import { Modal } from '@travelnest/merlin.modal';
import theme from '@travelnest/merlin.theme';
import React, { useEffect, useState } from 'react';
import { Character } from '../../../constants';
import { Paragraph } from '../../paragraph/Paragraph';

interface IPropertyShellCompletedStepProps {
	onRequestNext: () => any;
	onRequestPrevious: () => any;
	onRequestClose: () => any;
	onRequestSave: () => Promise<number>;
}

export const PropertyShellCompletedStep: React.FC<IPropertyShellCompletedStepProps> = (props) => {
	const [creating, setCreating] = useState(true);
	const [error, setError] = useState<string | null>(null);

	const createProperty = () => {
		props.onRequestSave().then((id) => {
			setCreating(false);
		}, (reason) => {
			setError(`${reason}`);
			setCreating(false);
		});
	};

	useEffect(createProperty, []);

	const completeButtonLoading = <Button loading={true}>Complete my property</Button>;

	const completeButton = <Button
		onClick={props.onRequestNext}
		bgColor={theme.colours.success.primary}
		color={theme.colours.text.white}
	>
		<span>Complete my property</span>
		<span className="travelnest-modal__icon">{Character.Right}</span>
	</Button>;

	const errorComponent = <Button
		bgColor={theme.colours.success.primary}
		color={theme.colours.text.white}
		onClick={() => {
			setCreating(true);
			setError(null);
		}}>Try again</Button>;

	return <Modal
		title="Add a new property"
		onRequestClose={props.onRequestClose}
		shouldCloseOnOverlayClick={false}
		actionRHS={error ? errorComponent : (creating ? completeButtonLoading : completeButton)}
	>
		{
			error ?
			<div>
				<InlineError text="Unable to save your property" />
				<Paragraph>
					We've encountered an error when trying to save your property.
					Please try again.
				</Paragraph>
			</div>
			:
			<div>
				<h3>Excellent!</h3>
				<Paragraph>We’ve taken this information and created a property profile for you.</Paragraph>
				<Paragraph>Take some time to review the information, and complete your property.</Paragraph>
				<Paragraph>It usually takes around 15 minutes.</Paragraph>
			</div>
		}
	</Modal>;
};
